import React from "react";

import { Home as StyledHome } from "./Home.styles.js";

import Loading from "../../components/Loading";

import { formatPhone } from '../../utils/formatter.js';
import { useWindowDimensions } from "../../utils/windowDimensionSize.js";

function Home({
	loading,
	document,
	setAcceptedTerms,
	acceptedTerms,
	submit
}) {
	const { width } = useWindowDimensions();

	if (!document || loading) {
		return <Loading />
	}

	return (
			<StyledHome>
				<StyledHome.Container>
					<StyledHome.Title>
						Olá, {document?.destinatary?.name}
					</StyledHome.Title>

					<StyledHome.Subtitle>
						Você recebeu o documento: <strong>{document?.title}.pdf</strong> para assinar.
					</StyledHome.Subtitle>


					<StyledHome.Card>
					<StyledHome.Card.Title>Remetente</StyledHome.Card.Title>
						<StyledHome.Card.Company>
							<StyledHome.Card.Company.Info>
								<StyledHome.Card.Company.Info.Name>{document?.company?.name}</StyledHome.Card.Company.Info.Name>

								<StyledHome.Card.Company.ContactInfo>
									{document?.company?.contact_email && (<StyledHome.Card.Company.Info.Contact>{document?.company?.contact_email}</StyledHome.Card.Company.Info.Contact>)}

									<StyledHome.Card.Company.Info.Contact>{formatPhone(document?.company?.contact_phone) || '-'}</StyledHome.Card.Company.Info.Contact>
								</StyledHome.Card.Company.ContactInfo>
							</StyledHome.Card.Company.Info>
						</StyledHome.Card.Company>
					</StyledHome.Card>

					{width >= 600 && (
						<StyledHome.Footer>
							<StyledHome.Footer.Terms>
								<StyledHome.Footer.Terms.Link href="https://drive.google.com/file/d/11f07WOLbgle_cbea8rGH7mq3d_ur982I/view?usp=drive_link" target="_blank" style={{ marginRight: '16px' }}>
									Termos de uso
								</StyledHome.Footer.Terms.Link>

								<StyledHome.Footer.Terms.Link href="https://drive.google.com/file/d/1O8hDS3SGx_jDPjL_eRZoiBxbJl_l0gB4/view?usp=drive_link" target="_blank">
									Política de Privacidade
								</StyledHome.Footer.Terms.Link>
							</StyledHome.Footer.Terms>

							<StyledHome.Footer.AcceptedTerm>
								<div style={{ marginRight: '8px' }}>
									<div className="onoffswitch">
										<input type="checkbox" checked={acceptedTerms} onChange={() => setAcceptedTerms(value => !value)} className="onoffswitch-checkbox" id="terms" />

										<label className="onoffswitch-label" htmlFor="terms"></label>
									</div>
								</div>

								<StyledHome.Footer.AcceptedTerm.Label className="privacy-declaration--text" htmlFor="terms">Declaro que li e estou  de acordo com os documentos citados acima</StyledHome.Footer.AcceptedTerm.Label>
							</StyledHome.Footer.AcceptedTerm>

							<StyledHome.Footer.Button className="af-button af-button--primary" disabled={!acceptedTerms} marginTop={16} type="primary" onClick={submit}>
								Visualizar para assinar
							</StyledHome.Footer.Button>
						</StyledHome.Footer>
					)}
				</StyledHome.Container>

				{width < 600 && (
					<StyledHome.FooterContainer>
						<StyledHome.Footer>
							<StyledHome.Footer.Terms>
								<StyledHome.Footer.Terms.Link href="https://drive.google.com/file/d/11f07WOLbgle_cbea8rGH7mq3d_ur982I/view?usp=drive_link" target="_blank" style={{ marginRight: '16px' }}>
									Termos de uso
								</StyledHome.Footer.Terms.Link>

								<StyledHome.Footer.Terms.Link href="https://drive.google.com/file/d/1O8hDS3SGx_jDPjL_eRZoiBxbJl_l0gB4/view?usp=drive_link" target="_blank">
									Política de Privacidade
								</StyledHome.Footer.Terms.Link>
							</StyledHome.Footer.Terms>

							<StyledHome.Footer.AcceptedTerm>
								<div style={{ marginRight: '8px' }}>
									<div className="onoffswitch">
										<input type="checkbox" checked={acceptedTerms} onChange={() => setAcceptedTerms(value => !value)} className="onoffswitch-checkbox" id="terms" />

										<label className="onoffswitch-label" htmlFor="terms"></label>
									</div>
								</div>

								<StyledHome.Footer.AcceptedTerm.Label className="privacy-declaration--text" htmlFor="terms">Declaro que li e estou  de acordo com os documentos citados acima</StyledHome.Footer.AcceptedTerm.Label>
							</StyledHome.Footer.AcceptedTerm>

							<StyledHome.Footer.Button className="af-button af-button--primary" disabled={!acceptedTerms} marginTop={16} type="primary" onClick={submit}>
								Visualizar para assinar
							</StyledHome.Footer.Button>
						</StyledHome.Footer>
					</StyledHome.FooterContainer>
				)}
			</StyledHome>
	);
}

export default Home;
